import { LeftOutlined, RightOutlined } from "@ant-design/icons";

import "./stylesMinimalPagination.css";

export type MinimalPaginationProps = {
  total: number;
  pageSize: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  itemLabel?: string;
  className?: string;
  prevAriaLabel?: string;
  nextAriaLabel?: string;
};

function MinimalPagination({
  total,
  pageSize,
  currentPage,
  onPageChange,
  itemLabel = "shown",
  className,
  prevAriaLabel = "Previous page",
  nextAriaLabel = "Next page",
}: MinimalPaginationProps) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  return (
    <div
      className={`minimal-pagination ${className ?? ""}`.trim()}
    >
      <span className="minimal-pagination-meta">
        Page {currentPage} of {totalPages}
        {" \u00b7 "}
        {total.toLocaleString()} {itemLabel}
      </span>
      <div className="minimal-pagination-nav">
        <button
          type="button"
          className="minimal-pagination-arrow"
          aria-label={prevAriaLabel}
          onClick={() => onPageChange(Math.max(1, currentPage - 1))}
          disabled={currentPage <= 1}
        >
          <LeftOutlined />
        </button>
        <button
          type="button"
          className="minimal-pagination-arrow"
          aria-label={nextAriaLabel}
          onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage >= totalPages}
        >
          <RightOutlined />
        </button>
      </div>
    </div>
  );
}

export default MinimalPagination;
